import { ChangeEvent, CSSProperties, KeyboardEvent } from 'react'
import styles from './style'

interface InputProps {
  style?: CSSProperties
  placeholder?: string
  setText?: (value: string) => void
  type?: string
  name?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
  autoComplete?: string | null
  value?: string | null
  required?: boolean
  autoCorrect?: string
}

function Input({
  style = {},
  placeholder,
  setText,
  type = 'text',
  name,
  onChange = () => undefined,
  onKeyDown,
  autoComplete = null,
  value = null,
  required = false,
  autoCorrect = 'off',
}: InputProps) {
  return (
    <input
      autoCorrect={autoCorrect}
      id={`input-${type}`}
      name={name ?? type}
      autoComplete={autoComplete ?? undefined}
      onChange={e => {
        if (setText) setText(e.target.value)
        onChange(e)
      }}
      onKeyDown={onKeyDown}
      value={value ?? undefined}
      placeholder={placeholder}
      type={type}
      style={{ ...styles.input, ...style }}
      required={required}
    />
  )
}

export default Input
